import { startCase } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { SnIntegrationsAPI } from '@lib/api/services';
import { SentryVaultComponent } from '@lib/vault';

import { FsLprReadsService, SnLprFlockRead } from '../../api';
import { QueryResultsMapViewComponent } from '../query-results-map-view/query-results-map-view.component';

@Component({
  selector: 'fs-flock-query-plate-card',
  templateUrl: './flock-query-plate-card.component.html',
  styleUrls: ['./flock-query-plate-card.component.scss'],
})
export class FlockQueryPlateCardComponent implements OnDestroy, OnInit {
  @Input() public plate: SnLprFlockRead;
  @Input() public query: string;
  @Input() public onMap: boolean;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _matDialog: MatDialog,
    private readonly _lprReadsService: FsLprReadsService,
    private readonly _integrationsAPI: SnIntegrationsAPI,
  ) {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public toStartCase(text: string): string {
    return startCase(text);
  }

  public setPlaceholderImage(event: any): void {
    event.target.src = '/assets/map-icons/No_Image_Found.png';
  }

  public sendToVault(plate: SnLprFlockRead): void {
    const dialog = this._matDialog.open(SentryVaultComponent);
    dialog
      .afterClosed()
      .pipe(takeUntil(this._destroy$))
      .subscribe((vaultID) => {
        const vault = vaultID.id || vaultID;
        if (vault) {
          this._addToVault(vault, plate.id, this.query);
        }
      });
  }

  public showOnMap(plate: SnLprFlockRead): void {
    this._matDialog.open(QueryResultsMapViewComponent, {
      data: plate,
      width: '75vw',
      hasBackdrop: true,
    });
  }

  private _addToVault(vaultID: string, plateId: string, queryId?: string): void {
    this._lprReadsService
      .addToVault(vaultID, plateId, queryId)
      .pipe(takeUntil(this._destroy$))
      .subscribe();
  }
}
